import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    realm: 'master',
    url: 'https://auth.daisywheel.fr/auth/',
    clientId: 'nebuchadnezzar',
});

export default keycloak;
